export default __webpack_public_path__ + "static/media/icon-master-data-active.7dd87898.svg";